import React, { useEffect, useState } from 'react'
import Grid2 from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment'
import Visibility from "@mui/icons-material/Visibility"
import VisibilityOff from "@mui/icons-material/VisibilityOff"
import sendPost from "../http/sendRequests"
import { useRequestUrl, usePasswordResetToken } from "../context/contextHooks"
import { Link } from 'react-router-dom'
import AlertMessage from "../utils/AlertMessage";
import {useSxStyles as sx} from "../styles/sxStyles";


const ProcessReset = () => {

	const [showNewPassword, setShowNewPassword] = useState(false)
	const [showConfirmPassword, setShowConfirmPassword] = useState(false)
	const [newPassword, setNewPasswordState] = useState('')
	const [confirmPassword, setConfirmPasswordState] = useState('')
	const [loading, setLoading] = useState(false)
	const [requestUrl] = useRequestUrl()
	const [passwordResetToken] = usePasswordResetToken()
	const [passwordResetMessage, setPasswordResetMessage] = useState({ success: false, message: '' })
	const [errorMessage, setErrorMessage] = useState('')

	useEffect(() => {
		setLoading(false)
	}, [loading])

	const toggleNewPassword = () => {
		setShowNewPassword(!showNewPassword)
	}

	const toggleConfirmPassword = () => {
		setShowConfirmPassword(!showConfirmPassword)
	}

	const handleReset = () => {
		setPasswordResetMessage({ success: false, message: '' })
		let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{12,20})");
		if (!newPassword) {
			setErrorMessage('Please enter New Password');
		} else if (!confirmPassword) {
			setErrorMessage('Please Re-enter New Password');
		} else if (newPassword !== confirmPassword) {
			setErrorMessage('Confirm password must match New Password');
		} else if (!strongRegex.test(newPassword)) {
			setErrorMessage('New password must contain 1 lowercase, 1 uppercase, 1 numeric, and 1 special character and must be between 12 and 20 characters long');
		} else {
			setLoading(true)
			const resetRequest = {token: passwordResetToken, password: newPassword}
			const url = `${requestUrl}/processReset`
			sendPost(url, resetRequest, '', getResetRespone, getErrorMessage)
		}
	}

	const getResetRespone = (response) => {
		setPasswordResetMessage(response)
	}

	const getErrorMessage = (response) => {
		setErrorMessage(response)
	}

	const disableMouseDown = (e) => {
		e.preventDefault();
	}

	const setNewPassword = (e) => {
		setNewPasswordState(e.target.value)
	}

	const setConfirmPassword = (e) => {
		setConfirmPasswordState(e.target.value)
	}


	return (
        (<Grid2 container spacing={5} direction="column" alignItems="center" justifyContent="center" style={{ maxHeight: '100vh' }}>
            <Grid2 size={12}>
				<Paper elevation={3} sx={sx.login}>
					{!passwordResetMessage.success && (errorMessage || passwordResetMessage.message) &&
					<AlertMessage title="Password Change Failed" severity="error" msg={errorMessage ? errorMessage : passwordResetMessage.message} />
					}
					<TextField
                        name="newPassword"
                        type={showNewPassword ? 'text' : 'password'}
                        style={{ margin: 8 }}
                        placeholder="New Password"
                        fullWidth
                        margin="normal"
                        value={newPassword}
                        onChange={setNewPassword}
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={toggleNewPassword}
                                            onMouseDown={disableMouseDown}
                                            size="large">
                                            {showNewPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            },

                            inputLabel: {
                                shrink: true,
                            }
                        }} />
					<TextField
                        name="confirmPassword"
                        type={showConfirmPassword ? 'text' : 'password'}
                        style={{ margin: 8 }}
                        placeholder="Confirm Password"
                        fullWidth
                        margin="normal"
                        value={confirmPassword}
                        onChange={setConfirmPassword}
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={toggleConfirmPassword}
                                            onMouseDown={disableMouseDown}
                                            size="large">
                                            {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            },

                            inputLabel: {
                                shrink: true,
                            }
                        }} />
					<Box>
					<Button variant="contained" color="primary" sx={sx.button} onClick={handleReset}>
						Reset Password
					</Button>
					</Box>
					{passwordResetMessage.success && <Typography>{passwordResetMessage.message} Please click <Link to="/login">here</Link> to login</Typography>}
				</Paper>
			</Grid2>
            <Backdrop sx={sx.backdrop} open={loading}>
				<CircularProgress color="inherit" />
			</Backdrop>
        </Grid2>)
    );
}

export default ProcessReset
